import _ from 'lodash';
import { createRefPath, createRefPath_client } from '../appData/appRefPaths';

export const updateFavorites = (dispatch, appUser, paps_state, swipedItem) => {

  const { pathViews } = paps_state ?? {}
  const { profileData, email } = appUser ?? {}
  const favs = appUser.settingsFavs ? appUser.settingsFavs : []
  const fav = swipedItem.key

  if (!_.includes(favs, fav)) {
    favs.push(fav)
  } else {
    _.remove(favs, function (n) {
      return n === fav;
    });
  }

  let _refPath;

  if (profileData?.id) {
    _refPath = createRefPath(['profiles', profileData.id])
  } else if (email) {
    _refPath = createRefPath_client(pathViews, ['profiles', email])
  }

  const d = { settingsFavs: favs }
  // database_fns.update_doc(_refPath, d, dispatch)
  database_fns.update_docc({
    refPath: _refPath,
    data: d,
    callback: dispatch
  })
}